import '../httpservices/core/ajax.httpservice.core';

class MedicationHttpService {

    GetMedications() {
        return $.get('api/Medication/GetMedications');
    }

    GetActiveMedications() {
        return $.get('api/Medication/GetActiveMedications?enableOutageResponse=1');
    }

    //model = ArchivePrescriptionMedicationRequest.cs
    ArchivePrescriptionMedication(model) {
        return $.post('api/Medication/ArchivePrescriptionMedication', model);
    }

    //model = ArchiveHomeMedicationRequest.cs
    ArchiveHomeMedication(model) {
        return $.post('api/Medication/ArchiveHomeMedication', model);
    }

    MedicationInformationSelect(drugNameId) {
        return $.get('api/Medication/MedicationInformation/' + drugNameId);
    }

    SaveMedication(model) {
        return $.post('api/Medication/SaveMedication', model);
    }

    SaveCustomDoseMedication(model) {
        return $.post('api/Medication/SaveCustomDoseMedication', model);
    }

    PageInit() {
        return $.get('Patient/Medication/PageInit');
    }

}

export const MedicationHttpSvc = new MedicationHttpService();